React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_bulk_actions_board_options_list')

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    @state = {
      boards: null
    }

  componentDidMount: ->
    @props.getSelectedBoards.then (boards) =>
      @setState
        boards: boards

  render: t.renderable ->
    { eventHandlers, boardPlurality } = @props

    if !@state.boards?
      t.div ->
        t.div '.spinner.loading'
    else
      t.div '.bulk-action-options-list', =>
        t.ul '.pop-over-list', =>
          t.li =>
            t.a
              onClick: => eventHandlers.bulkUpdateTeamVisible(@state.boards)
            , =>
              t.span =>
                t.format ['team-visible', 'label']
              t.span '.sub-name', =>
                t.format ['team-visible', "actionName-#{boardPlurality}"]



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/bulk-actions/board-options-list-component.coffee